// extracted by mini-css-extract-plugin
module.exports = {"full-image":"FullImage_full-image__ehrQB"};